import { useEffect } from "react";
import { PageLayout } from "~/components/PageLayout";
import { RegisterForm } from "~/features/auth/components/RegisterForm";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";
import { trackEvent } from "~/utils/analytics";

export const RegisterPage = () => {
  useTrackPageVisit("app/register/visit");

  useEffect(() => {
    trackEvent({ eventName: "app/register/visit" });
  }, []);

  return (
    <PageLayout>
      <RegisterForm />
    </PageLayout>
  );
};
